import { Input, Form, Select } from 'antd';
import styles from './index.module.scss';
import { Rule } from 'antd/es/form';

type Props = {
  label: string;
  name1: string;
  name2: string;
  placeholder1?: string;
  placeholder2?: string;
  rules?: Rule[];
  warningTags?: { label: string; value: string }[];
  disabled?: boolean;
};

const WarningTagsInput = ({
  label,
  name1,
  name2,
  placeholder1,
  placeholder2,
  rules=[],
  warningTags = [],
  disabled = false
}: Props) => {
  return (
    <div>
      <div>{label}</div>
      <div className={styles['warning-tags__input']}>
        <Form.Item
          name={name1}
          rules={rules[0] ? [rules[0]] : []}
          style={{ marginBottom: 0 }}
        >
          <Input
            placeholder={placeholder1}
            size="large"
            disabled={disabled}
          />
        </Form.Item>

        <Form.Item
          name={name2}
          rules={rules[1] ? [rules[1]] : []}
          style={{ marginBottom: 0 }}
        >
          <Select
            placeholder={placeholder2}
            size="large"
            allowClear  
            showSearch
            disabled={disabled}
            options={[
              ...warningTags,
            ]}
            optionFilterProp="label"
            style={{ width: 200 }}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default WarningTagsInput;
